var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-layout"},[_c('div',{attrs:{"id":"header"}},[_c('CfssHeader')],1),_c('div',{staticClass:"page-contents",style:({ height: `calc(100vh - ${_vm.headerHeight}px)` })},[_c('router-view',{key:_vm.$route.fullPath}),_c('CfssFooterComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }